import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { IsNullOrEmpty } from "../../../helpers/utility";
import { getCategoryList } from "../../../store/shopping/shopping.selector";
import { getLiveStreams } from "../../../store/social/social.selector";
import {
    getPrivateLoungeRequest,
    updatePrivateLoungeRequest,
} from "../../../store/user/privatelounge/privatelounge.actions";
import { getCurrentPrivateLounge } from "../../../store/user/privatelounge/privatelounge.selector";
import { getMySubscriptionsRequest } from "../../../store/user/user.actions";
import {
    getMySubscriptions,
    getSearchedUsers,
    getUserProfile,
} from "../../../store/user/user.selector";
import {
    getVIPCircleRequest,
    getVIPSubscriptionRequest,
} from "../../../store/user/vipcircle/vipcircle.actions";
import {
    getCurrentVIPCircle,
    getVIPSubscriptions,
} from "../../../store/user/vipcircle/vipcircle.selector";

const SetSubscription = (props) => {
    const location = useLocation();
    const scrollRef = useRef(null);
    const dispatch = useDispatch();
    const [mode, setMode] = useState("lounge");
    const [form, setForm] = useState(false);
    const [isAdd, setAdd] = useState(false);
    const [annuallySubscription, setAnnuallySubscription] = useState("");
    const [monthlySubscription, setMonthlySubscription] = useState("");
    const [description, setDescription] = useState("");
    const [type, setType] = useState("set");

    useEffect(() => {
        if (location && location.hash) {
            setMode("vip");
        }
    }, [location]);

    const {
        privacylounge,
        users,
        liveStreams,
        categories,
        vipCircles,
        userProfile,
        mySubscriptions,
        vipSubscriptions,
    } = useSelector((state) => {
        return {
            privacylounge: getCurrentPrivateLounge(state),
            categories: getCategoryList(state),
            vipCircles: getCurrentVIPCircle(state),
            userProfile: getUserProfile(state),
            mySubscriptions: getMySubscriptions(state),
            vipSubscriptions: getVIPSubscriptions(state),
            liveStreams: getLiveStreams(state),
            users: getSearchedUsers(state),
        };
    });

    useEffect(() => {
        dispatch(getPrivateLoungeRequest());
        dispatch(getVIPCircleRequest());
        dispatch(getMySubscriptionsRequest());
        dispatch(getVIPSubscriptionRequest());
    }, []);

    useEffect(() => {
        setAdd(false);
    }, [vipCircles]);

    useEffect(() => {
        if (privacylounge) {
            setAnnuallySubscription(privacylounge.annuallySubscription);
            setMonthlySubscription(privacylounge.monthlySubscription);
            setDescription(privacylounge.description);
        }
    }, [privacylounge]);

    const validate = () => {
        return (
            !IsNullOrEmpty(monthlySubscription) &&
            !IsNullOrEmpty(annuallySubscription) &&
            !IsNullOrEmpty(description)
        );
    };

    const handleSave = () => {
        if (validate()) {
            dispatch(
                updatePrivateLoungeRequest({
                    monthlySubscription: monthlySubscription,
                    description: description,
                    annuallySubscription: annuallySubscription,
                })
            );
        } else {
            setForm(true);
        }
    };

    const scrollH = (e) => {
        e = window.event || e;
        let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
        scrollRef.current.scrollLeft -= delta * 40;
    };

    return (
        <div className="p-2 sm:p-4 lg:px-8 h-full overflow-hidden flex flex-col">
            <div className="">
                <div className="mb-3">
                    <h2 className="text-xl font-bold text-ebony-color capitalize">
                        set Subscription
                    </h2>
                    <p className="text-sm font-medium text-black-60">
                        Manage your subscription
                    </p>
                </div>

                {/* <div className="p-4 pb-0 bg-white rounded-lg rounded-br-none rounded-bl-none border border-b-0 border-black-10">
                    <ul
                        onWheel={(e) => scrollH(e)}
                        ref={scrollRef}
                        className="flex items-center pb-[6px] border-b border-black-10 overflow-x-auto no-scrollbar"
                    >
                        <li>
                            <NavLink
                                to="/page/manage-subscription/private-lounge"
                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] px-6 hover:border-b-2 border-orange-color capitalize marketplace-nav whitespace-nowrap"
                            >
                                Private lounge
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/page/manage-subscription/vip-circle"
                                className="text-sm font-medium text-black-60 hover:text-orange-color pb-[7px] px-6 hover:border-b-2 border-orange-color capitalize marketplace-nav whitespace-nowrap"
                            >
                                VIP circle
                            </NavLink>
                        </li>
                    </ul>
                </div> */}
            </div>

            <div className="flex-grow overflow-y-auto p-4 bg-white rounded-lg rounded-tr-none rounded-tl-none border border-t-0 border-black-10">
                <Outlet />
            </div>
        </div>
    );
};

export default SetSubscription;
